// extracted by mini-css-extract-plugin
module.exports = {"videoInstruction":"styles_videoInstruction__ztYpH"};